import React from 'react';

function SvgTgColoredSolid({ size = 30 }) {
  return (
    <svg width={size} viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M21.9622 0.143667C22.2635 0.0164576 22.5932 -0.0274162 22.917 0.016612C23.2409 0.0606403 23.5471 0.190961 23.8037 0.394011C24.0604 0.59706 24.2581 0.865415 24.3762 1.17114C24.4944 1.47687 24.5288 1.8088 24.4758 2.13237L21.7111 18.9581C21.4429 20.5811 19.6681 21.5118 18.1846 20.7034C16.9437 20.027 15.1006 18.985 13.4428 17.8977C12.6139 17.3534 10.0747 15.6106 10.3868 14.3704C10.655 13.31 14.9214 9.32522 17.3594 6.95614C18.3162 6.02539 17.8799 5.48846 16.7499 6.34461C13.9438 8.4703 9.43842 11.7029 7.94883 12.6128C6.63477 13.4152 5.9497 13.5521 5.13055 13.4152C3.63608 13.1656 2.2501 12.7792 1.11889 12.3083C-0.409714 11.6723 -0.335356 9.56372 1.11767 8.94974L21.9622 0.143667Z" fill="url(#paint0_linear_25732_6814)"/>
      <defs>
        <linearGradient id="paint0_linear_25732_6814" x1="1225" y1="0" x2="1225" y2="2100" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2AABEE"/>
          <stop offset="1" stopColor="#229ED9"/>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SvgTgColoredSolid;
